import type { Virtualizer } from '@tanstack/react-virtual';
import type { ReactNode, RefObject } from 'react';
import { useEffect } from 'react';
import { useSearch } from '../hooks/useSearch';

interface VirtualizedListProps {
  parentRef: RefObject<HTMLDivElement>;
  rowVirtualizer: Virtualizer<HTMLDivElement, Element>;
  renderRow: (virtualRow: { index: number; start: number }) => ReactNode;
}

export const VirtualizedList = ({ parentRef, rowVirtualizer, renderRow }: VirtualizedListProps) => {
  const { category, search } = useSearch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    rowVirtualizer.scrollToIndex(0);
  }, [search, category]);

  return (
    <div ref={parentRef} className='relative h-[500px] w-full overflow-auto'>
      {category.componentFilters?.({ category })}
      <div className='relative w-full' style={{ height: `${rowVirtualizer.getTotalSize()}px` }}>
        {rowVirtualizer.getVirtualItems().map(renderRow)}
      </div>
    </div>
  );
};
